
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class AccountingCompanyStatusModel extends Model<AccountingCompanyStatusModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'inDebtCollection', type: 'boolean' },
		{ name: 'hasOverdueLedgers', type: 'boolean' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public inDebtCollection: boolean;
	public hasOverdueLedgers: boolean;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.inDebtCollection = false;
		this.hasOverdueLedgers = false;
		
	}
	getProperties(){
		return AccountingCompanyStatusModel.classProperties;
	}
}

